import React, { useState, useEffect } from "react";
import "./releases.scss";
import { truncate } from "lodash";
import { useSelector } from 'react-redux'

import { Http } from "../../../../../helpers/axois";
import { GCPENDPOINT } from "../../../../../constant/common";

import { CreateRelease } from "./CreateRelease";

import placeholderImg from '../../../../../assets/images/imagePlaceholder.png';
import { ReactComponent as AngleDown } from "../../../../../assets/svg/angle-down.svg";
import { ReactComponent as AngleUp } from "../../../../../assets/svg/angleup.svg";


const getFormatDescription = (value: string, length: number) =>
  truncate(value, { length, separator: " " });

export const Releases: React.FC<any> = ({ productId, preview }) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [versions, setVersions] = useState<any>([])
  const [dropId, setDropId] = useState(0);

  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const { name, preview_image, description } = preview;
  const handleClick = (id: any) => {
    if (id === dropId) {
      setDropId(-1);
    } else {
      setDropId(id);
    }
  }

  const showModal = (): void => {
    setVisible(true)
  }

  useEffect(() => {
    Http
      .get(`/orgs/${orgId}/store/products/${productId}/release`).subscribe((res: any) => {
        if (res) {
          setVersions(res.versions);
        }
      })
  }, [orgId, productId])

  return (
    <div className="release-container">
      <div className="release-header">
        <p>Releases</p>
        <button onClick={showModal} >Add Versions</button>
      </div>
      {visible &&
        <CreateRelease visible={visible} setVisible={setVisible} productId={productId} versions={versions} />
      }
      <div className="dropdown-container">
        {versions.map((version: any, index: number) => {
          const { installs, reviews, version_tag } = version
          return (
            <div
              key={index}
              className={`dropdown ${dropId === version && 'active'}`}
            >
              <div className="head">
                <p>Version: {version_tag} </p>
                <div className="head-end">
                  <button className="is_published">Published</button>
                  <div className="dropdown-icon" onClick={() =>
                    handleClick(version)}>
                    {dropId === version ? <AngleUp /> : <AngleDown />}
                  </div>
                </div>
              </div>
              <div className="dropdown-content">
                <div className="list">
                  <h6>Builds</h6>
                  <div className="content-body">
                    <img
                      src={preview_image ? `${preview_image.startsWith("https://") ? preview_image : GCPENDPOINT + preview_image}` : placeholderImg}
                      alt="icon"
                      className="img-icon"
                    />
                    <div className="img-description">
                      <span>
                        {name}
                      </span>
                      <p>
                        {getFormatDescription(description, 25)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="list">
                  <h6>status</h6>
                  <div className="is_published">Published</div>
                </div>
                <div className="list">
                  <h6>installs</h6>
                  <p>{installs}</p>
                </div>
                <div className="list">
                  <h6>Reviews</h6>
                  <p>{reviews} {" "}User reviews</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
